// Hardware-Free Cloud Deployment
import hardwareFreeHeader from "assets/images/Hardware Free - Header.png";
import hardwareFreeLeft from "assets/images/Hardware Free Left.png";
import hardwareFreeRight from "assets/images/HardwareFree Right.png";

// Forensic Ledger & Audit
import forensicLedgerHeader from "assets/images/ForensicLedgerHeader.png";
import forensicLedgerLeft from "assets/images/ForensicLedgerLeft.png";
import forensicLedgerRight from "assets/images/ForensicLedgerRight.png";

// Revenue Recapture & ROI
import revenueRecaptureHeader from "assets/images/RevenueRecaptureHeader.png";
import revenueRecaptureLeft from "assets/images/RevenueRecaptureLeft.png";
import revenueRecaptureRight from "assets/images/RevenueRecaptureRight.png";

// Effortless Scalability
import effortlessScalabilityHeader from "assets/images/Effortless ScalabilityHeader.png";
import effortlessScalabilityLeft from "assets/images/Effortless ScalabilityLeft.png";
import effortlessScalabilityRight from "assets/images/Effortless ScalabilityRight.png";

// Advanced Card Security
import advancedCardSecurityHeader from "assets/images/Advanced Card Securityheader.png";
import advancedCardSecurityLeft from "assets/images/Advanced Card Security Left.png";
import advancedCardSecurityRight from "assets/images/Advanced Card Security Right.png";

// Secure User Experience
import secureUserExpHeader from "assets/images/SecureUserExp.Header.png";
import secureUserExpLeft from "assets/images/SecureUserExp.Left.png";
import secureUserExpRight from "assets/images/SecureUserExp.Right.png";

export const forensicBlocks = [
  {
    title: "HARDWARE-FREE DEPLOYMENT",
    powerStat: "0% TECHNICAL DEBT",
    description:
      "100% web-based and cloud-native, integrates seamlessly into any operational workflow. Activate and redeem from any device - tablet, laptop, or POS - without new software. Process redemptions, voids, and replacements instantly with zero technical overhead.",
    headerIcon: hardwareFreeHeader,
    leftIcon: hardwareFreeLeft,
    rightIcon: hardwareFreeRight,
  },
  {
    title: "FORENSIC LEDGER & AUDIT",
    powerStat: "100% AUDIT ACCURACY",
    description:
      'Audit the end-to-end movement of every card with a live, verifiable ledger. From issuance to redemption, you get the <strong>\u201cWho, Where, and When\u201d</strong> needed for total branch accountability. <strong>Eliminate manual reconciliation</strong> by automatically syncing branch sales with corporate liability.',
    headerIcon: forensicLedgerHeader,
    leftIcon: forensicLedgerLeft,
    rightIcon: forensicLedgerRight,
  },
  {
    title: "ADVANCED CARD SECURITY",
    powerStat: "100% FRAUD PROTECTION",
    description:
      'Stop \u201ccard-guessing\u201d scams and internal errors. We use <strong>High-Entropy voucher numbers</strong> - random, unpredictable sequences - and <strong>Hashed PINs</strong> to ensure sensitive data is never stored in plain text. This multi-layered defense prevents card-cloning and unauthorized use, making your gift cards secure, unhackable, and fully under your control.',
    headerIcon: advancedCardSecurityHeader,
    leftIcon: advancedCardSecurityLeft,
    rightIcon: advancedCardSecurityRight,
  },
  {
    title: "SECURE USER EXPERIENCE",
    powerStat: "ZERO-FRICTION CUSTOMER AUTONOMY",
    description:
      '<strong>Role-Based Access Control (RBAC)</strong> ensures internal security by restricting high-level actions to authorized staff only. Simultaneously, frictionless balance-check URL links give customers instant autonomy, reducing your support overhead and maximizing customer satisfaction.',
    headerIcon: secureUserExpHeader,
    leftIcon: secureUserExpLeft,
    rightIcon: secureUserExpRight,
  },
  {
    title: "EFFORTLESS SCALABILITY",
    powerStat: "INSTANT BULK ACTIVATION",
    description:
      "Whether you\u2019re issuing a single digital card to a loyal customer or bulk-activating thousands for a corporate partner, our interface handles high-volume requests in seconds. Grow across unlimited branches without hitting a performance ceiling.",
    headerIcon: effortlessScalabilityHeader,
    leftIcon: effortlessScalabilityLeft,
    rightIcon: effortlessScalabilityRight,
  },
  {
    title: "REVENUE RECAPTURE & ROI",
    powerStat: "REAL-TIME BREAKAGE RECOGNITION",
    description:
      "Stop guessing at your liability. Our real-time visibility helps you <strong>pinpoint unclaimed revenue (breakage)</strong> with surgical precision, turning a passive balance sheet item into an active, recognized profit engine.",
    headerIcon: revenueRecaptureHeader,
    leftIcon: revenueRecaptureLeft,
    rightIcon: revenueRecaptureRight,
  },
];
